import HtmlContent from './HtmlContent';

export default function HtmlContentWrapper({ html, className = '' }) {
    return <HtmlContent html={html} className={className} />;
}
